export const EVENT_NODE_TYPES = [
    'onLoadFinished',
    /** @deprecated Prefer onLoadFinished; kept so legacy graphs still run. */
    'onLoad',
    'onStart',
    'onClick',
    'onHitboxClick',
    'onTrayChoiceChanged',
    'onPlayerPlay',
    'onPlayerPlayAndAudioActive',
    'onPlayerTrackFinished',
    'onPlayerTrackFinishedAndAudioActive',
    'onPlayerPaused',
    'onPlayerPausedAndAudioActive',
];
export const RUN_NODE_TYPES = [
    'rotateTo',
    'moveTo',
    'scaleTo',
    'characterMoveTo',
    'delay',
    'playAnimation',
    'playVideo',
    'playAudio',
    'prefetchAsset',
    'translateText',
    'textToSpeech',
    'stopAnimation',
    'stopAllAnimationsOfObject',
    'stopAllAnimations',
    'stopVideo',
    'stopAllVideos',
    'stopAudio',
    'stopAllAudio',
    'stopPlayback',
    'stopAllPlayback',
    'setVisible',
    'fadeVisible',
    'setSkySphere',
    'playerLoadTrack',
    'playerPlay',
    'playerPause',
    'playerShow',
    'traySpawnChoice',
    'trayHighlight',
    'trayDisableInput',
    'trayEnableInput',
    'print',
    'printVar',
    'logNotification',
];
